import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { ServiceIcon } from 'components/common/ServiceIcon'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import { BazaarVoiceRating } from 'components/common/Rating'
import Link from 'components/common/Link/Link'
import Image from 'components/common/Image'

const RecentlyViewedItem = ({
  skuImagePath,
  iconName,
  brandName,
  productName,
  rating,
  skuUrl,
  ...props
}) =>
  <Wrapper data-at-recently-viewed-item>
    <Link to={ skuUrl }>
      {
        iconName ?
          <ServiceIconWrapper>
            <ServiceIcon iconName={ iconName } full margin={ 'auto' } />
          </ServiceIconWrapper> :
          skuImagePath &&
          <TireImage
            data-at-recently-viewed-image
            src={ `${skuImagePath}?$BOT-TireDetail-RecentlyViewed-Desktop-h144$` } />
      }
      <Title data-at-recently-viewed-brand>{ brandName }</Title>
      <Title data-at-recently-viewed-product>{ productName }</Title>
    </Link>
    { !iconName && <BazaarVoiceRating reviewName={ productName } { ...props } small showStarsOnly /> }
  </Wrapper>

RecentlyViewedItem.propTypes = {
  brandName: PropTypes.string,
  iconName: PropTypes.string,
  productName: PropTypes.string,
  rating: PropTypes.number,
  skuImagePath: PropTypes.string,
  skuUrl: PropTypes.string
}

export default RecentlyViewedItem

const Wrapper = styled.div`
  display: block;
  position: relative;
  ${Mixin.responsive('width', '144px', '188px')}
  margin: 0 auto;
  vertical-align: middle;
`

const Title = styled.div`
  margin-bottom: 9px;
  line-height: 20px;
  color: ${Theme.colors.black};
  text-align: left;
  ${Mixin.font.GothamBold(14, 600)}
`

const TireImage = styled(Image)`
  width: auto;
  ${Mixin.responsive('height', '144px', '188px')}
  margin: 0 0 10px;
  border: 1px solid ${Theme.colors.light_grey};
`

const ServiceIconWrapper = styled.div`
  width: 100%;
  padding: 25px;
  height: 144px;
  background-color: ${Theme.colors.white};
  margin: 0 0 10px;
  border: 1px solid ${Theme.colors.light_grey};
`
